import { el } from 'redom';

import InputRow from 'generics/components/text-input-row/row';

import ParticipantsInput from './input';

class ParticipantsSection {

  constructor(configuration) {

    this.input = new ParticipantsInput(configuration);

    this.el = el('#calendar-activity-participants-section-main', [
      new InputRow({
        label: configuration.placeholder,
        input: this.input
      })
    ]);

  }

  getValue() {

    return this.input.getValue();

  }

  setErrors(errors) {}

  clearErrors() {}

}

export default ParticipantsSection;